<template>
    <div class="color-select flex y-top x-left">
        <a 
            :style="{width:size+'px',height:size+'px',lineHeight:size+'px',background:'#eee'}" 
            @click="handleClickEvent('')" 
            href="javascript:;" 
            class="medcon error-color fs16 med-jinyong">
        </a>
        <a 
            v-for="(item,index) in colors" :key="index" 
            class="ml5" 
            :class="{'selected':value == item}"
            :style="{width:size+'px',height:size+'px',background:item}" 
            @click="handleClickEvent(item)" 
            href="javascript:;">
        </a>
    </div>
</template>

<script>
export default {
    name: "ColorSelect",
    components: {},
    props: {
        value:{
            type:String,
        },
        size:{
            type:[String,Number],
            default:20,
        }
    },
    data() {
        return {
            colors:['#6c73de','#5aa2ef','#57bad4','#99be5c','#e9bb42','#cc5864','#9448ab'],
        }
    },
    methods: {
        handleClickEvent(color){
            this.$emit('change',color);
        }
    },
    mounted() {
        
    },
}
</script>

<style lang="less" scoped>
.color-select{
    a{
        text-align: center;
        display: inline-block;
        border:2px solid transparent;
        &.selected{
            position: relative;
            border-color:#bdc1d7;
            &:before{
                content:'';
                width:6px;
                height:12px;
                display: inline-block;
                border-color:#fff;
                border-style:solid;
                border-width:0 2px 3px 0;
                transform: rotate(45deg);
                position:absolute;
                left: 50%;
                top: 50%;
                margin-left: -0.08rem;
                margin-top: -0.16rem;
            }

        }
    }
}
</style>